import { memo } from 'react'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from '@mui/material'
import ProductInventoryLotsPanel from './ProductInventoryLotsPanel'

function ProductInventoryViewDialog({ open, product, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ fontWeight: 600, bgcolor: '#e3f2fd' }}>
        Inventory Information
      </DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <Typography variant="body2" sx={{ color: '#666', mb: 2 }}>
          Product: <strong>{product?.product_name}</strong>
          {product?.sku ? (
            <>
              {' '}
              · Article Code: <strong>{product.sku}</strong>
            </>
          ) : null}
        </Typography>
        <ProductInventoryLotsPanel sku={product?.sku} />
      </DialogContent>
      <DialogActions sx={{ p: 2, bgcolor: '#f8f9fb' }}>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}

export default memo(ProductInventoryViewDialog)
